import { Component, Input, OnInit } from '@angular/core';
import { AlertService, IAlertType, ProjectsStoreService } from '../../../_shared/services';
import { Projects, StatusButtons } from '../../../_shared/interfaces';
import { ClrDatagridModule, ClrDatagridSortOrder } from "@clr/angular";
import { RouterLink } from "@angular/router";
import { DatePipe, NgIf } from "@angular/common";
import { getTenantStorage } from '../../../_shared/utils/tenant-context';
import moment from 'moment';

@Component({
  selector: 'app-my-projects-card',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    NgIf
  ],
  templateUrl: './my-projects-card.component.html',
  styleUrl: './my-projects-card.component.sass'
})

export class MyProjectsCardComponent implements OnInit {
  projects: Projects[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  companyID: string = '';

  @Input() childMessage: string = '';
  @Input() projectID: string = '';
  @Input() employeeID: string = '';

  statusButtons: StatusButtons[] = [
    { state: '', display: '---', label: 'alert-danger', icon: 'info-circle'},
    { state: 'open', display: 'Offen', label: 'alert-info', icon: 'info-circle'},
    { state: 'requested', display: 'Projekt', label: 'alert-info', icon: 'info-circle'},
    { state: 'lost', display: 'Verloren', label: 'alert-danger', icon: 'check-circle'},
    { state: 'confirmed', display: 'Auftrag', label: 'alert-info', icon: 'info-circle'},
    { state: 'running', display: 'In Arbeit', label: 'alert-warning', icon: 'info-circle'},
    { state: 'invoiced', display: 'Berechnet', label: 'alert-danger', icon: 'check-circle'},
    { state: 'finished', display: 'Erledigt', label: 'alert-success', icon: 'info-circle'}
  ];

  constructor(
    private prss: ProjectsStoreService,
    private alertDispatcher: AlertService,
  ) { }

  ngOnInit() {
    this.loading = true;
    const staffId = parseInt(getTenantStorage('staff_id') ?? getTenantStorage('user_id') ?? '0', 10);
    this.loadList(staffId);
    this.companyID = this.childMessage;
  }

  loadList(userID: number) {
    this.prss.getProjectsByUser(userID)
      .subscribe({
        next: data => {
          if (!data || !data.object || data.object.length === 0) {
            this.alertDispatcher.alertConfig.message = 'Keine Projekte gefunden!';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
            return;
          }
          this.projects = data.object;
        },
        complete: () => {
          this.loading = false;
        },
        error: () => {
          return
        }
      });
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(projectstatus: string) {
    const statusline = this.findButtonStatus(projectstatus, this.statusButtons);
    const fallbackIndex = 0;
    const idx = statusline >= 0 ? statusline : fallbackIndex;
    return {
      'statusLabel' : this.statusButtons[idx].label,
      'statusDisplay': this.statusButtons[idx].display,
      'statusIcon': this.statusButtons[idx].icon
    };
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus).statusLabel + " alert-sm";
  }

  formatProjectDate(value: string | null | undefined): string {
    if (!value) {
      return '-';
    }

    const parsed = moment(value, ['DD.MM.YYYY', 'YYYY-MM-DD'], true);
    return parsed.isValid() ? parsed.format('DD.MM.YYYY') : value;
  }
}
